
        <div class="back-to-home">
            <a href="" class="back-button btn btn-icon btn-primary"><i data-feather="arrow-left" class="icons"></i></a>
        </div>
        
        <section class="bg-home d-flex align-items-center position-relative" style="background: url('assets/images/shape01.png') center;">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card form-signin p-4 rounded shadow">
                            <form>
                                <a routerLink="/index"><img src="assets/images/logo-icon.png" class="avatar avatar-small mb-4 d-block mx-auto" alt=""></a>
                                <h5 class="mb-3 text-center">Reset your password</h5>

                                <p class="text-muted">Please enter your email address. You will receive a link to create a new password via email.</p>
                            
                                <div class="form-floating mb-3">
                                    <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com">
                                    <label for="floatingInput">Email address</label>
                                </div>
                
                                <button class="btn btn-primary w-100" type="submit">Send</button>

                                <div class="col-12 text-center mt-3">
                                    <p class="mb-0 mt-3"><small class="text-dark me-2">Remember your password ?</small> <a routerLink="/auth-bs-login" class="text-dark fw-bold">Sign in</a></p>
                                </div><!--end col-->

                                <p class="mb-0 text-muted mt-3 text-center">© {{year}} Landrick.</p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
